enum ProcessingTypeStatus {
  NETWORK_DAMAGE = 'NETWORK_DAMAGE',
  COVID_ClIENT = 'COVID_ClIENT',
  COVID_UP = 'COVID_UP',
  ESC = 'ESC',
  IG = 'IG',
  OBS = 'OBS',
  SAV = 'SAV',
  SAV_CLOT = 'SAV_CLOT',
  WISP = 'WISP',
  NO_STATUS = 'NO_STATUS'
}

export default ProcessingTypeStatus;
